import * as React from 'react';

export function GripVerticalIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<circle cx='9' cy='12' r='1' />
			<circle cx='9' cy='5' r='1' />
			<circle cx='9' cy='19' r='1' />
			<circle cx='15' cy='12' r='1' />
			<circle cx='15' cy='5' r='1' />
			<circle cx='15' cy='19' r='1' />
		</svg>
	);
}
